import React, { useMemo, memo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Col,
  Row,
  Input,
} from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';
import Button from 'components/App/Button';

import 'flatpickr/dist/themes/material_blue.css';
import styles from './ModalEditPolicyCurfew.module.scss';

const optionFlatpickr = {
  enableTime: true,
  noCalendar: true,
  dateFormat: 'H:i',
  minuteIncrement: 1,
  time_24hr: true,
};

function ModalEditPolicyCurfew(props) {
  const {
    isOpen,
    hasCurfew,
    curfewFrom,
    curfewTo,
    actionGetPlaceDetail,
    actionEditCurfewPolicy,
    onToggleModal,
  } = props;

  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const onCallBackSave = () => {
    onToggleModal();
    actionGetPlaceDetail({ placeId });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      hasCurfew: !!hasCurfew,
      curfewFrom: curfewFrom || '00:00',
      curfewTo: curfewTo || '12:00',
    },
    onSubmit: (values) => {
      const result = {
        hasCurfew: values.hasCurfew,
        curfewPolicy: values.hasCurfew ? {
          from: values.curfewFrom,
          to: values.curfewTo,
        } : null,
        placeId,
        onCallBackSave,
      };
      actionEditCurfewPolicy(result);
    },
  });

  const handleRadioChange = (e) => {
    validation.setFieldValue(e.target.name, !!+e.target.value);
  };

  const handleTimeChange = (_, currentDate, self) => {
    validation.setFieldValue(self.element.name, currentDate);
  };

  const CloseButton = useMemo(() => (
    <button className={styles.ButtonClose} onClick={onToggleModal} type="button">
      <CloseButtonSvg />
    </button>
  ), [onToggleModal]);

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="lg"
        isOpen={isOpen}
        toggle={onToggleModal}
        className={styles.Modal}
      >
        <ModalHeader
          toggle={onToggleModal}
          className={styles.ModalHeader}
          close={CloseButton}
        />
        <ModalBody className={styles.ModalBody}>
          <form onSubmit={validation.handleSubmit}>
            <Label className="Label">
              Chính sách giờ giới nghiêm
            </Label>

            <hr className="Divider" />

            <Row className="Block__Container mb-30">
              <Col md="5" className="Block__Title">
                Giờ giới nghiêm
              </Col>

              <Col md="7" className="Block__Content__Wrapper">
                <div className="Block__Content__Deposit">
                  <label className="Block__Checkbox__Wrapper">
                    <Input
                      type="radio"
                      className="Block__Checkbox"
                      name="hasCurfew"
                      value="1"
                      onChange={handleRadioChange}
                      checked={validation.values.hasCurfew === true}
                    />
                    <div className="Block__Checkbox__Name">Có</div>
                  </label>

                  <label className="Block__Checkbox__Wrapper">
                    <Input
                      type="radio"
                      className="Block__Checkbox"
                      name="hasCurfew"
                      value="0"
                      onChange={handleRadioChange}
                      checked={validation.values.hasCurfew === false}
                    />
                    <div className="Block__Checkbox__Name">Không</div>
                  </label>
                </div>
              </Col>
            </Row>

            {validation.values.hasCurfew && (
              <>
                <hr className="Divider" />

                <Row className="Block__Container mb-30">
                  <Col md="6">
                    <div className="Block__Title mb-8">Từ</div>
                    <Flatpickr
                      name="curfewFrom"
                      className="Section__Content__TimePicker"
                      value={validation.values.curfewFrom}
                      options={optionFlatpickr}
                      onChange={handleTimeChange}
                    />
                  </Col>

                  <Col md="6">
                    <div className="Block__Title mb-8">Đến</div>
                    <Flatpickr
                      name="curfewTo"
                      className="Section__Content__TimePicker"
                      value={validation.values.curfewTo}
                      options={optionFlatpickr}
                      onChange={handleTimeChange}
                    />
                  </Col>
                </Row>
              </>
            )}

            <hr className="Divider" />

            <div className="Button__Wrapper">
              <Button
                classes="Button Button__Cancel"
                onClick={onToggleModal}
              >
                Hủy
              </Button>

              <Button classes="Button Button__Save" type="submit">
                Lưu
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
}

ModalEditPolicyCurfew.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  hasCurfew: PropTypes.bool,
  curfewFrom: PropTypes.string,
  curfewTo: PropTypes.string,
  actionGetPlaceDetail: PropTypes.func.isRequired,
  actionEditCurfewPolicy: PropTypes.func.isRequired,
  onToggleModal: PropTypes.func.isRequired,
};

ModalEditPolicyCurfew.defaultProps = {
  hasCurfew: false,
  curfewFrom: '00:00',
  curfewTo: '12:00',
};

export default memo(ModalEditPolicyCurfew);
